export const hasOwnProperty = (
  obj: Record<string, any> | undefined,
  property: string,
) => {
  if (typeof obj !== 'object' && obj !== null) return false

  return Object.prototype.hasOwnProperty.call(obj, property)
}
